<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" label-width="90px">
      <el-row :gutter="10" class="mb8">
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="文章标题" prop="title">
            <el-input v-model="queryParams.title" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="租户名称" prop="tenantName">
            <el-input v-model="queryParams.tenantName" placeholder="请输入" clearable />
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="首页推荐" prop="homePageRecommend">
            <el-select
              v-model="queryParams.homePageRecommend"
              placeholder="请选择"
              clearable
               style="width:100%"
            >
              <el-option
                v-for="dict in statusList"
                :key="dict.value"
                :label="dict.name"
                :value="dict.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="列表排版" prop="listStyle">
            <el-select v-model="queryParams.listStyle" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="item in listStyleList" :key="item.value" :label="item.name" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="标签" prop="tag">
            <el-select v-model="queryParams.tag" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="item in tagList" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="6">
          <el-form-item label="推荐置顶" prop="homePageTopFlag">
            <el-select v-model="queryParams.homePageTopFlag" placeholder="请选择" clearable style="width:100%">
              <el-option v-for="item in homePageTopFlagList" :key="item.value" :label="item.name" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="12" :lg="7">
          <el-form-item label="创建时间" prop="createTime">
            <el-date-picker
              v-model="queryParams.createTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:100%">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :md="24" :lg="24" align="right">
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetQuery">清空</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button type="primary" :disabled="multiple" @click="batchOnline">上线</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button type="primary" :disabled="multiple"  @click="batchOffline">下线</el-button>
      </el-col>
    </el-row>

    <el-table v-loading="loading" :data="dataList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" fixed="left" align="center"/>
      <el-table-column label="文章标题" min-width="200" align="center" prop="title" fixed="left"/>
      <el-table-column label="封面图" min-width="250" align="center" fixed="left">
        <template slot-scope="scope">
          <el-image v-for="item in scope.row.headPicUrlList" style="width: 80px;margin-right: 5px"
                    :src="item" :preview-src-list="[item]" fit="contain"/>
        </template>
      </el-table-column >
      <el-table-column label="列表排版" min-width="100" align="center" prop="listStyleDesc" fixed="left">
        <template slot-scope="scope">
          <span>{{scope.row.contentType === 1? scope.row.listStyleDesc : ''}}</span>
        </template>
      </el-table-column>
      <el-table-column label="类型" min-width="80" align="center" prop="contentTypeStr" />
      <el-table-column label="标签" min-width="100" align="center" prop="tags" />
      <el-table-column label="租户名称" min-width="100" align="center" prop="tenantName" />
      <el-table-column label="状态" min-width="80" align="center" prop="statusStr" />
      <el-table-column label="点击量" min-width="80" align="center" prop="readCount" />
      <el-table-column label="点赞量" min-width="80" align="center" prop="likesCount" />
      <el-table-column label="推荐" min-width="90" align="center" prop="statusStr">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.homePageRecommend === 1" @change="recommendChange($event, scope.row)"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="推荐置顶" min-width="90" align="center" prop="homePageTopFlag">
        <template slot-scope="scope">
          <div style="text-align:left">置顶：{{ scope.row.homePageTopFlag === 1 ? '是' : '否' }}</div>
          <div style="text-align:left" v-if="scope.row.homePageTopFlag === 1">样式：{{ scope.row.topStyleDesc }}</div>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="170" align="center" prop="createTime" />
      <el-table-column label="操作" min-width="130" align="center" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-button type="text" @click="handleSee(scope.row)">查看</el-button>
          <el-button
            type="text"
            @click="handleChangeStatus(scope.row)"
            v-if="scope.row.status === 1"
          >下线</el-button>
          <el-button
            type="text"
            @click="handleChangeStatus(scope.row)"
            v-if="scope.row.status === 2"
          >上线</el-button>
          <el-button
            type="text"
            @click="showTopSet(scope.row)"
          >置顶设置</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="companyArticleListPage"
    />
    <AddTextArticleDialog ref="addTextDialogRef" @success="getList"></AddTextArticleDialog>
    <TopSetDialog ref="topSetDialogRef" @success="companyArticleListPage"></TopSetDialog>
  </div>
</template>

<script>
import {
  companyArticleListPage,
  changeStatusArticle,
  batchChangeStatus,
  articleDelete,
  articleDetail,
  changeHomePageRecommend,
  changeHomePageTop
} from "@/api/saas/package";
import { amountFormat } from "@/utils/index";
import AddTextArticleDialog from "@/views/saas/manage/briefcase/components/addTextDialog";
import TopSetDialog from "@/views/saas/manage/briefcase/components/topSetDialog";

export default {
  name: "BusinessList",
  props: {
    customerId: {},
    contactId: {},
    height: {
      type: String,
      default() {
        return "250";
      }
    }
  },
  data() {
    return {
      total: 0,
      loading: false,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        createTime: [],
        title: null,
        tenantName: null,
        homePageRecommend: null,
        listStyle: null,
        tag: null,
        homePageTopFlag: null
      },
      statusList: [{
        value: 1,
        name: '已推荐'
      },{
        value: 0,
        name: '未推荐'
      }],
      listStyleList: [
        {value: 1, name: '左标题右图'},
        {value: 2, name: '上标题下1图'},
        {value: 3, name: '上标题下3图'},
        {value: 4, name: '仅标题'}
      ],
      homePageTopFlagList: [
        {value: 0, name: '未置顶'},
        {value: 1, name: '已置顶'},
      ],
      tagList: [],
      dataList: [],
      amountFormat,
      // 非多个禁用
      multiple: true,
      selection: [],
    };
  },
  created() {
    this.getDicts("article_tag").then(response => {
      this.tagList = response.data;
    });
    this.companyArticleListPage();
  },
  components: {
    AddTextArticleDialog,
    TopSetDialog
  },
  methods: {
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.companyArticleListPage();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.queryParams.userId = null;
      this.handleQuery();
    },
    handleSee(row) {
      this.$router.push({
        path: "/hydrosp/enterpriseArticleDetail",
        query: {
          id: row.articleId
        }
      });
    },
    handleChangeStatus(row) {
      const that = this
      this.$confirm("是否更改该文章状态?", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(function() {
          changeStatusArticle({
            articleId: row.articleId,
            status: row.status === 2 ? 1 : 2
          }).then(response => {
              that.companyArticleListPage();
              that.msgSuccess("文章状态更新成功");
            })
            .catch(error => {
              that.loading = false
            });
        })
        .then(() => {});

    },
    // 删除文章
    handleDelete(row) {
      let that = this;
      this.$confirm("是否确认删除该文章?", "警告", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(function() {
          that.delete(row);
        })
        .then(() => {});
    },
    delete(row) {
      articleDelete({
        articleId: row.articleId
      })
        .then(response => {
          this.companyArticleListPage();
          this.msgSuccess("文章删除成功");
        })
        .catch(error => {
          this.loading = false;
        });
    },
    // 编辑文章
    handleEdit(row){
      articleDetail({ articleId: row.articleId })
        .then(response => {
          this.$refs.addTextDialogRef.open(response.data);
        })
        .catch(error => {});
    },
    handleAddText() {
      this.$refs.addTextDialogRef.open();
    },
    getList() {
      this.queryParams.pageNum = 1;
      this.companyArticleListPage();
    },
    companyArticleListPage() {
      this.loading = true;
      companyArticleListPage({
        ...this.queryParams,
        createTimeStart: this.queryParams.createTime && this.queryParams.createTime[0],
        createTimeEnd: this.queryParams.createTime && this.queryParams.createTime[1]
      })
        .then(response => {
          this.dataList = response.rows || [];
          this.loading = false;
          this.total = response.total;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    recommendChange(e, row) {
      changeHomePageRecommend({
        articleId: row.articleId,
        homePageRecommend: e ? 1:0
      })
        .then(response => {
          this.msgSuccess(e ? '推荐成功' : '取消推荐成功')
          this.companyArticleListPage()
        })
        .catch(error => {
          this.loading = false;
        });
    },
    topChange (e, row) {
      changeHomePageTop({
        articleId: row.articleId,
        homePageTopFlag: e ? 1 : 0
      })
        .then(response => {
          this.msgSuccess(e ? '置顶成功' : '取消置顶成功')
          this.companyArticleListPage()
        })
        .catch(error => {
          this.loading = false;
        });
    },
    /** 详细按钮操作 */
    toDetail(row) {
      this.$router.push("/crm/business/detail/" + row.id);
    },
    showTopSet (row) {
      this.$refs.topSetDialogRef.showTopSet(row)
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection;
      this.multiple = !selection.length;
    },
    batchOnline(){
      this.selection.forEach(item => item.status=1);//1上线，2下线
      batchChangeStatus(this.selection).
      then(response => {
        this.msgSuccess("上线成功")
        this.companyArticleListPage();
      }).catch(error => {
        this.loading = false;
      });
    },
    batchOffline(){
      this.selection.forEach(item => item.status=2);//1上线，2下线
      batchChangeStatus(this.selection).
      then(response => {
        this.msgSuccess("下线成功")
        this.companyArticleListPage();
      }).catch(error => {
        this.loading = false;
      });
    },
  }
};
</script>
